import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { decodeShortCode } from "../../lib/shortUrl";
import { supabase } from "../../lib/supabase";

export default function ShortRedirectPage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Buscando artículo...");

  useEffect(() => {
    async function resolve() {
      if (!code) {
        navigate("/actualidad", { replace: true });
        return;
      }
      const id = decodeShortCode(code);
      if (id === null) {
        navigate("/actualidad", { replace: true });
        return;
      }

      const { data, error } = await supabase
        .from("articles")
        .select("slug")
        .eq("id", id)
        .maybeSingle();

      if (error || !data) {
        setStatus("Artículo no encontrado. Redirigiendo...");
        setTimeout(() => navigate("/actualidad", { replace: true }), 1500);
        return;
      }

      navigate(`/articulo/${data.slug}`, { replace: true });
    }

    resolve();
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F7FB]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600 text-sm font-medium">{status}</p>
      </div>
    </div>
  );
}